import React from 'react';

import { mfaManagementRoute as route } from 'routes/constants';

const RouteComponent = React.lazy(() => import('./MfaManagementPage'));

export default {
  RouteComponent,
  path: route,
  // name is required for React keys in createRoute.js and WrappedRoute.js (Suspense)
  // even though this page doesn't use Redux/sagas. Using name instead of path ensures
  // stable component reconciliation when paths change.
  name: 'mfaManagement',
};
